const Lang = () => {
    return (
        <div>
            <div class="dropdown">
                <button
                    class="btn btn-outline-warning dropdown-toggle" data-mdb-ripple-color="dark "
                    type="button"
                    id="dropdownMenuButton"
                    data-mdb-toggle="dropdown"
                    aria-expanded="false"
                >
                    Забонхо
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li><a class="dropdown-item" href="#">Точики   <i class="flag flag-tajikistan"></i> </a></li>
                    <li><a class="dropdown-item" href="#">Русский  <i class="flag flag-russia"></i></a></li>
                    <li><a class="dropdown-item" href="#">English  <i class="flag flag-united-states"></i></a></li>
                </ul>
            </div>
        </div>
    )
}

export default Lang;